export const BLOG_ROOT = '/blog';
export const BLOG_POST = `${BLOG_ROOT}/:slug`;
export const BLOG_POST_PREVIEW = `${BLOG_ROOT}/p/:slug`;
